/*
 * @Author: xym
 * @Date: 2020-09-14 20:16:50
 * @Last Modified by: mikey.zhaopeng
 * @Last Modified time: 2023-08-Tu 05:04:36
 */

import sa from 'sa-sdk-javascript'
import { appUser } from '@/utils'
import { setCookie } from '@/utils/common/cookie'

export default function init(type, data) {
  sa.init({
    server_url: 'https://sc-ylsn.ylyk.com/v1/sa/sa', // 神策正式项目
    // server_url: 'https://pv.ylyk.com/sa?project=production', // 神策正式项目
    cross_subdomain: false, //不在根域下设置 cookie，二级域名各自独立
    heatmap: {
      // 是否开启点击图，默认 default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭
      clickmap: 'default',
      // 是否开启触达注意力图，默认 default 表示开启，自动采集 $WebStay 事件，可以设置 'not_collect' 表示关闭
      scroll_notice_map: 'default',
      get_vtrack_config: false
    },
    show_log: false,
    is_single_page: true,
    send_type: type || 'ajax',
    datasend_timeout: 1500,
    queue_timeout: 1500,
    app_js_bridge: true
  })
  console.log('[sa] 登录', appUser.userId)
  sa.login(appUser.userId)
  sa.registerPage({
    user_Id: appUser.userId,
    token: 'COiG9w0FB4egh4Imk$gJ6CzsBaQqn6QJQ',
    ylsn_token: 'COiG9w0FB4egh4Imk$gJ6CzsBaQqn6QJQ',
    project: 'ylsn'
  })

  if (data) {
    sa.registerPage({
      ...data
      // current_url: location.href,
      // referrer: document.referrer
    })
  }

  // sa.quick('getAnonymousID');
  // 前端方式获取匿名 ID  https://manual.sensorsdata.cn/sa/latest/sdk-api-web-42795073.html
  sa.quick('isReady', function () {
    var anonymousId = sa.quick('getAnonymousID')
    setCookie('anonymousId', anonymousId)
    console.log(anonymousId, 'anonymousID')
  })
  sa.quick('autoTrack', {
    platform: appUser.isNative ? 'native' : 'h5'
  })
}

// 神策痕迹上报
export function saTrack(name, params, type) {
  if (name) {
    sa[type || 'track'](name, params)
  } else {
    sa[type](params)
  }
  console.log('[sa] 痕迹 ' + name, params)
}
